import React, { useEffect, useState } from 'react';

import ErrorPanel from 'components/Error/Error';
import IdTitleSelect from 'components/IdTitleSelect';
import { ICreateEntryProps } from './CreateEntry.types';
import { Backdrop } from 'components/Backdrop/Backdrop';

const CreateEntry = ({
  projectVersionId,
  entryTypes,
  creatingEntry,
  onCreate,
}: ICreateEntryProps) => {
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [entryType, setEntryType] = useState<string>('');
  const [signature, setSignature] = useState<string>('');
  const [title, setTitle] = useState<string>('');

  const onCreateEntry = () => {
    onCreate(signature, entryType, title);
    setIsEditing(false);
  };

  const disableBackdrop = () => {
    setIsEditing(false);
  };

  useEffect(() => {
    if (creatingEntry.status === 'SAVED') {
      setIsEditing(false);
      setSignature('');
      setEntryType('');
      setTitle('');
    }
  }, [creatingEntry.status]);

  return (
    <>
      <button
        className="primary add-button"
        id="create_entry"
        onClick={() => {
          setIsEditing(true);
        }}
        disabled={isEditing}
      >
        Eintrag hinzufügen
      </button>
      {isEditing && (
        <>
          <Backdrop disableBackdrop={disableBackdrop} />
          <div className="create-room shadow">
            {creatingEntry.status === 'FAILED' &&
              creatingEntry.messages &&
              !!creatingEntry.messages.entryType && (
                <ErrorPanel message={creatingEntry.messages.entryType} />
              )}
            <IdTitleSelect
              allowEmpty
              options={entryTypes}
              onSelect={(e) => setEntryType(e.currentTarget.value)}
            />
            <input
              placeholder="Titel"
              type="text"
              onChange={(e) => setTitle(e.currentTarget.value)}
            />
            <input
              placeholder="Signatur"
              type="text"
              onChange={(e) => setSignature(e.currentTarget.value)}
            />
            <button className="primary" onClick={() => onCreateEntry()} disabled={!entryType}>
              OK
            </button>
            <button className="secondary" onClick={() => setIsEditing(false)}>
              Abbrechen
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default CreateEntry;
